import './ProgressBar.css'

export function ProgressBar({ value, maxValue }: { value: number; maxValue: number }) {
  const percentage = (value / maxValue) * 100
  return (
    <div className="progress-bar-container">
      <div className="progress-bar-fill" style={{ width: `${percentage}%` }} />
    </div>
  )
}
